// Local tokens prevent aborted requests from completing a newer action.
export function createClientTimings({ now, visible = () => true, record }) {
  const pending = new Map();
  let next = 0;
  return {
    start(name) {
      const token = ++next;
      pending.set(name, { token, at: now(), visible: visible() });
      return token;
    },
    finish(name, token) {
      const action = pending.get(name);
      if (!action || action.token !== token) return false;
      pending.delete(name);
      const ms = now() - action.at;
      if (!action.visible || !visible() || ms < 0 || ms > 60_000) return false;
      record(name, Math.round(ms));
      return true;
    },
    hide() { pending.clear(); },
  };
}
